/**
 * Custom user agent checks.
 */
export class UserAgent {
  /**
   */
  public static isMobile: boolean;

  /**
   */
  public static init() {
    // Snippet from CC framework.
    UserAgent.isMobile =
      navigator.userAgent.match(
        /BlackBerry|Windows Phone|Android|iPad|iPhone|Silk|iPod|Kindle|Nexus/i
      ) !== null;

    UserAgent.isMobile =
      UserAgent.isMobile ||
      (navigator.userAgent.match(/Chrome/i) !== null &&
        navigator.userAgent.match(/Apple/i) !== null &&
        navigator.userAgent.match(/Linux/i) !== null);
  }

  /**
   * Custom check for Kindle used for fixing flickering bug with
   * canvas transparency or preserveDrawingBuffer.
   */
  public static isKindle: boolean = !!window.navigator.userAgent.match(/Kindle|Silk|KFA/);

  /**
   * IE Check
   */
  public static isIe: boolean =
    !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g); // whether IE

  /**
   */
  public static isAmazon: boolean = !!window.navigator.userAgent.match(
    /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA|KFFOWI)\b)/i
  );

  /**
   * Custom check for Crios to correct device motion data implementation
   * inconsistency.
   */
  public static isCrios: boolean = !!window.navigator.userAgent.match(
    /^.*(iPhone|iPad).*(OS\s[0-9]).*(CriOS|Version)\/[.0-9]*\sMobile.*$/i
  );

  /**
   */
  public static isiPad2: boolean =
    !!window.navigator.userAgent.match(/iPad/i) && screen.height * window.devicePixelRatio < 1050;

  /**
   */
  public static isLenovo: boolean = UserAgent.checkIsLenovo();

  /**
   * Lenovo useragent fix as per Sky spec.
   */
  public static checkIsLenovo(): boolean {
    let isAndroid = UserAgent.getAndroidVersion() > -1;
    let lenovoRes = window.screen && window.screen.width === 1024 && window.screen.height === 600;
    return isAndroid && lenovoRes && navigator.userAgent.indexOf("Lenovo") > -1;
  }

  public static getAndroidVersion(userAgent?: string): number {
    userAgent = (userAgent || navigator.userAgent).toLowerCase();
    var match = userAgent.match(/android\s([0-9\.]*)/);
    if (match) {
      let float = parseFloat(match[1]);
      return float;
    }
    return -1;
  }
}

UserAgent.init();
